<svg:g xmlns:svg="http://www.w3.org/2000/svg" *ngIf="config">
    <!-- Axis ink follows the host's `color` (currentColor), so charts theme with the app
         instead of hardcoding black. Hosts that set no color keep the old near-black look. -->
    <svg:g fill="none" class="y-axis" text-anchor="end">
        <svg:line class="axis-line" stroke="currentColor" stroke-opacity="0.55" [attr.x1]="config.s.x" [attr.x2]="config.s.x" [attr.y1]="config.s.y" [attr.y2]="config.e.y"></svg:line>
        <svg:g *ngFor="let step of config.ySteps" class="tick" [attr.transform]="'translate('+config.s.x+','+step.y+')'">
            <svg:line class="tick" stroke="currentColor" stroke-opacity="0.55" x2="-6" y1="0" y2="0"></svg:line>
            <!-- Guides stop at the axis end (e.x); the zero line reads stronger as the baseline. -->
            <svg:line class="guide" stroke="currentColor" [attr.stroke-opacity]="step.isZero ? 0.45 : 0.12" x1="0" [attr.x2]="config.e.x - config.s.x" y1="0" y2="0"></svg:line>
            <svg:text fill="currentColor" fill-opacity="0.85" font-size="11" x="-10" y="0" dy="0.32em">
                {{step.text}}
            </svg:text>
        </svg:g>
    </svg:g>

    <svg:g fill="none" class="y-axis" text-anchor="middle">
        <svg:line class="axis-line" stroke="currentColor" stroke-opacity="0.55" [attr.x1]="config.s.x" [attr.x2]="config.e.x" [attr.y1]="config.e.y" [attr.y2]="config.e.y"></svg:line>
        <svg:g *ngFor="let step of config.xSteps" class="tick" [attr.transform]="'translate('+step.x+','+config.e.y+')'">
            <!-- Dense charts: vertical labels (reading bottom-to-top) in a fixed-height band. -->
            <svg:text fill="currentColor" fill-opacity="0.85"
                      [attr.x]="step.rotate ? -8 : 0"
                      [attr.y]="step.rotate ? 4 : 20"
                      [attr.transform]="step.rotate ? 'rotate(-90)' : null"
                      [attr.text-anchor]="step.rotate ? 'end' : null"
                      [attr.font-size]="step.rotate ? 11 : 12">
                {{step.text}}
            </svg:text>
            <svg:title *ngIf="step.fullText && step.fullText !== step.text">{{step.fullText}}</svg:title>
        </svg:g>
    </svg:g>
</svg:g>
